import { render, staticRenderFns } from "./changeTransitStatusAction.vue?vue&type=template&id=768e38c7&"
import script from "./changeTransitStatusAction.vue?vue&type=script&lang=js&"
export * from "./changeTransitStatusAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports